import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchPages, fetchChapter } from '../../actions';
import BookLink from './book-link';

class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bId: this.props.match.params.bookID,
      cId: this.props.match.params.chapterID,
    };
  }

  componentDidMount() {
    this.props.fetchChapter(this.state.bId, this.state.cId);
    this.props.fetchPages(this.state.bId, this.state.cId);
  }

  renderCreatePage = () => {
    if (this.props.loggedIn) {
      return (
        <BookLink className="create-link" to={`/books/${this.state.bId}/chapters/${this.state.cId}/pages/newpage`}>
          <button type="button" id="create-chapter">
            <i className="fas fa-feather-alt" />
            <p>Add Your Story</p>
          </button>
        </BookLink>
      );
    } else {
      return (
        <div className="signin-prompt">
          <p>Sign in to contribute your own story to this chapter.</p>
        </div>
      );
    }
  }

  render() {
    return (
      <div id="pages-container">
        <div className="pages">
          <h1 className="title">{this.props.currentChapter?.title}</h1>
          {this.renderCreatePage()}
          <div className="pages-listing-container">
            {this.props.pages.map((page) => {
              return (
                <BookLink className="pages-link" key={page.id} to={`/books/${this.state.bId}/chapters/${this.state.cId}/pages/${page.id}`}>
                  <div className="pages-listing-item" key={page.id}>
                    <div className="pages-listing fold">
                      <h2>{page.title}</h2>
                    </div>
                  </div>
                </BookLink>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => (
  {
    currentBook: state.books.current,
    currentChapter: state.chapters.current,
    pages: state.pages.all,
    loggedIn: state.auth.authenticated,
  }
);

export default withRouter(connect(mapStateToProps, { fetchPages, fetchChapter })(Pages));
